export const REF_NAME = 'INSPECTIONCOMPANY';
export const REF_PATH = 'inspectioncompany';
export const NAME = 'Inspection company';
